import { render, staticRenderFns } from "./Paper.vue?vue&type=template&id=074f4aa6&scoped=true&"
import script from "./Paper.vue?vue&type=script&lang=ts&"
export * from "./Paper.vue?vue&type=script&lang=ts&"
import style0 from "./Paper.vue?vue&type=style&index=0&id=074f4aa6&scoped=true&lang=scss&"
import style1 from "./Paper.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "074f4aa6",
  null
  
)

export default component.exports